module.exports = __webpack_public_path__ + "newsletter-icon-40d07e61749f119a103e.gif";